export const SOFTLINE_API_ESL_ASSOCIATE = '/v1/esl/associate';
export const SOFTLINE_API_ESL_DISSOCIATE = '/v1/esl/dissociate';
